import { IFireSightLayerDefinition } from '../interfaces/fire-sight/IFireSightModels';

export const FIRE_SIGHT_MONITORING_PRODUCT_CODES = [
  'thermal_ir38',
  'ros_nrt',
  'observed_smooth',
  'observed_perimeters',
] as const;

export const FIRE_SIGHT_SIMULATION_LAYER_DEFINITIONS: readonly IFireSightLayerDefinition[] = [
  {
    productCode: 'forecast_spread',
    label: 'Potential Footprint',
    kind: 'vector',
    defaultVisible: true,
  },
  {
    productCode: 'elevation',
    label: 'Elevation',
    kind: 'raster',
    defaultVisible: false,
  },
  {
    productCode: 'fuel_map',
    label: 'Fuel',
    kind: 'raster',
    defaultVisible: false,
  },
  {
    productCode: 'fireline_intensity',
    label: 'Fireline Intensity',
    kind: 'raster',
    defaultVisible: false,
  },
  {
    productCode: 'flame_length',
    label: 'Flame Height',
    kind: 'raster',
    defaultVisible: false,
  },
  {
    productCode: 'rate_of_spread',
    label: 'Rate of Spread',
    kind: 'raster',
    defaultVisible: false,
  },
  {
    productCode: 'road_risk',
    label: 'Exposed Roads',
    kind: 'vector',
    defaultVisible: false,
  },
] as const;

export const FIRE_SIGHT_DEFAULT_SIMULATION_PRODUCT_CODE = 'forecast_spread';
export const FIRE_SIGHT_SIMULATION_REPORT_PRODUCT_CODE = 'report_pdf';
export const FIRE_SIGHT_FIRE_OBJECT_PRODUCT_CODE = 'observed_smooth';
export const FIRE_SIGHT_SIMULATION_BASE_PRODUCT_CODES = [
  'fire_state',
  'observed_smooth',
] as const;

export const FIRE_SIGHT_HISTORY_PAGE_SIZE = 10;
